<template>
    
    <main class="hp-bg-color-dark-90 d-flex min-vh-100" id="mainScroll">

        

        <!-- SIDEBAR -->
        <SidebarBody/>

        

        <div class="hp-main-layout" style="overflow-x: hidden;">

            <!-- HEADER -->
            <HeaderBody/>
            
            <!-- MAIN CONTENT -->
            <div class="hp-main-layout-content no-pad" >

                <div class="row mb-32 gy-8 dash-top" >

                    <div class="col-12">

                        <div class="row g-32">

                            

                            <div class="col-12 col-xl-8">

                                <h2 class="dd-none" style="margin-top: -70px;"></h2>
                                

                                <div class="row gy-0">

                                    <div class="col-12">

                                        <div class="card hp-card-4">

                                            <div class="card-bod">
                                                <div style="width: 100%; height: 250px; ">

                                                    <img :src="profileBack" alt="" style="width: 100%; height: 100%; object-fit: cover; " class="profB">

                                                    <div style="width: 100%; justify-content: flex-end; align-items: center; display: flex; margin-top: 10px; margin-right: 10px; padding-right: 10px;">

                                                        <button class="btn btn-icon-only rounded-circle btn-outline-primary" style="margin-right: 10px;" @click="share">
                                                            <i class="hp-text-color-dark-0 ri-share-line"></i>
                                                        </button>

                                                        <button class="btn btn-sm btn-primary" style=" color: #fff;  border-style: none !important;  padding: 8px 15px; border-radius: 15px;" data-bs-toggle="modal" data-bs-target="#editProfile">
                                                        
                                                            Edit Profile

                                                        </button>

                                                    </div>

                                                </div>

                                                <img :src="profilePic" alt="" style="border-radius: 50%; width: 90px; height: 90px; object-fit: cover;  border-color: #b2bec3; border-width: 1px; border-style: solid; margin-left: 20px; margin-top: -50px;">

                                                <div style="margin-left: 20px; margin-top: 10px; position: relative;">
                                                    <h5 style="width: 250px; white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">{{ displayName }}

                                                        <span v-if="userType == 'model'">
                                                            <img src="@/assets/img/check-circle.png" alt="" style="width: 16px; height: 16px; margin-left: 2px;">
                                                        </span>
                                                        
                                                        <span v-if="sexuality == 'gay'">
                                                            <img src="@/assets/img/gay.png" alt="" style="width: 16px; height: 16px; margin-left: 5px;">
                                                        </span>

                                                        <span v-else-if="sexuality == 'lesbian'">
                                                            <img src="@/assets/img/lesibian.png" alt="" style="width: 16px; height: 16px; margin-left: 5px;">
                                                        </span>

                                                        <span v-else-if="sexuality == 'bisexual'">
                                                            <img src="@/assets/img/bisexual.png" alt="" style="width: 16px; height: 16px; margin-left: 5px;">
                                                        </span>

                                                    </h5>
                                                
                                                    <p style="margin-top: -15px;">@{{ userName }}</p>

                                                    
                                                </div>

                                                <!-- <div style="margin-left: 20px; margin-top: 20px;" class="d-flex align-items-center">
                                                    <i class="hp-text-color-dark-0 iconly-Light-Calendar"></i>
                                                
                                                    <span style="margin-left: 10px;">Joined October 2023</span>
                                                </div> -->

                                                <div >

                                                    <div v-if="userType == 'user'" style="margin-top: 25px; margin-bottom: 0px; margin-left: 20px; cursor: pointer;" class="d-flex" @click="goUserList" >

                                                        <div class="d-flex">
                                                            <strong>{{ kFormatter(followersCount) }}</strong>
                                                            <p style="margin-left: 5px;">Followers</p>
                                                        </div>

                                                        <div class="d-flex" style="margin-left: 20px;">
                                                            <strong>{{ kFormatter(followingCount) }}</strong>
                                                            <p style="margin-left: 5px;">Following</p>
                                                        </div>

                                                        <div class="d-flex" style="margin-left: 20px;">
                                                            <strong>{{ kFormatter(likes) }}</strong>
                                                            <p style="margin-left: 5px;">Likes</p>
                                                        </div>

                                                    </div>

                                                    <div v-else style="margin-top: 25px; margin-bottom: 0px; margin-left: 20px; cursor: pointer;" class="d-flex" @click="goUserList" >

                                                        <div class="d-flex">
                                                            <strong>{{ kFormatter(followersCount) }}</strong>
                                                            <p style="margin-left: 5px;">Followers</p>
                                                        </div>

                                                        <div class="d-flex" style="margin-left: 20px;">
                                                            <strong>{{ kFormatter(fanCount) }}</strong>
                                                            <p style="margin-left: 5px;">Fans</p>
                                                        </div>

                                                        <div class="d-flex" style="margin-left: 20px;">
                                                            <strong>{{ kFormatter(likes) }}</strong>
                                                            <p style="margin-left: 5px;">Likes</p>
                                                        </div>

                                                    </div>

                                                    

                                                </div>

                                                <div style=" margin-left: 20px;" >
                                                    <p class="hp-p1-body">{{ bio }}</p> 

                                                </div>

                                                <div style=" margin-left: 20px; cursor: pointer; margin-top: 30px;" class="d-flex">

                                                    <a :href="twitterLink" target="_blank" v-if="twitter != ''" style="margin-right: 10px;">
                                                        <button class="btn btn-sm btn-primary" style="border-radius: 25px; padding: 0; background-color: #F1F2F4 !important; padding-left: 0px; padding-right: 20px; border: none;">
                                                            <img src="@/assets/img/twitter.png" alt="" style="width: 30px; object-fit: cover; margin-right: 10px; border-radius: 50%;" >
                                                            <span class="hp-p1-body hp-text-color-dark-100" >Twitter</span>
                                                        </button>
                                                    </a>

                                                    <a :href="instagramLink" target="_blank" v-if="instagram != ''" style="margin-right: 10px;">
                                                        <button class="btn btn-sm btn-primary" style="border-radius: 25px; padding: 0; background-color: #F1F2F4 !important; padding-left: 0px; padding-right: 20px; border: none;">
                                                            <img src="@/assets/img/instagram.png" alt="" style="width: 30px; object-fit: cover; margin-right: 10px; border-radius: 50%;" >
                                                            <span class="hp-p1-body hp-text-color-dark-100" >Instagram</span>
                                                        </button>
                                                    </a>

                                                    <a :href="facebookLink" target="_blank" v-if="facebook != ''" style="margin-right: 10px;">

                                                        <button class="btn btn-sm btn-primary" style="border-radius: 25px; padding: 0; background-color: #F1F2F4 !important; padding-left: 0px; padding-right: 20px; border: none;">
                                                            <img src="@/assets/img/tiktok.png" alt="" style="width: 30px; object-fit: cover; margin-right: 10px; border-radius: 50%;" >
                                                            <span class="hp-p1-body hp-text-color-dark-100" >TikTok</span>
                                                        </button>

                                                        
                                                    </a>

                                                    <a :href="snapLink" target="_blank" v-if="snap != ''" style="margin-right: 10px;">

                                                        <button class="btn btn-sm btn-primary" style="border-radius: 25px; padding: 0; background-color: #F1F2F4 !important; padding-left: 0px; padding-right: 20px; border: none;">
                                                            <img src="@/assets/img/snap.png" alt="" style="width: 30px; object-fit: cover; margin-right: 10px; border-radius: 50%;" >
                                                            <span class="hp-p1-body hp-text-color-dark-100" >Snapchat</span>
                                                        </button>

                                                        
                                                    </a>

                                                    
                                                </div>

                                                <div style="padding: 10px; margin-top: 20px; ">

                                                    <!-- TABS -->
                                                    <ul class="nav nav-tabs mb-12" id="profileTab" role="tablist" >
                                                        <li class="nav-item" role="presentation">
                                                            <h5 class="nav-link active" id="posts-tab" data-bs-toggle="tab" data-bs-target="#posts"  role="tab" aria-controls="posts" aria-selected="true" style="cursor: pointer; padding-left: 30px; padding-right: 30px;">
                                                                {{ postCount }} <span style="padding-left: 5px;"></span>
                                                                Posts
                                                            </h5>
                                                        </li>

                                                        <li class="nav-item" role="presentation">
                                                            <h5 class="nav-link" id="media-tab" data-bs-toggle="tab" data-bs-target="#media"  role="tab" aria-controls="media" aria-selected="false" style="cursor: pointer;padding-left: 30px; padding-right: 30px;">
                                                                {{mediaCount}} <span style="padding-left: 5px;"></span>
                                                                Media
                                                            </h5>
                                                        </li>

                                                    </ul>

                                                    <div class="tab-content" id="allTabContent" style="padding-bottom: 200px;">

                                                        <!-- POSTS -->
                                                        <div class="tab-pane fade show active" id="posts" role="tabpanel" aria-labelledby="posts-tab" style="overflow-y: scroll;">
                                                            
                                                            <div class="col-12" style="margin-bottom: 20px;" v-for="(post, index) in postsList" :key="'number'+index">

                                                                <div class="card hp-card-4" v-if="post.isLoading">
                                                                    <div class="card-body">
                                                                        <lv-skeleton primaryColor="#607c8a" secondaryColor="#8aa6b5" :width="100" :height="10"/><br>
                                                                        <lv-skeleton primaryColor="#607c8a" secondaryColor="#8aa6b5" :width="100" :height="10"/>
                                                                        <br><br>

                                                                        <div class="mm-none">
                                                                            <lv-skeleton primaryColor="#607c8a" secondaryColor="#8aa6b5" :width="600" :height="10"/><br>
                                                                            <lv-skeleton primaryColor="#607c8a" secondaryColor="#8aa6b5" :width="600" :height="10"/><br>
                                                                            <lv-skeleton primaryColor="#607c8a" secondaryColor="#8aa6b5" :width="600" :height="10"/>
                                                                        </div>

                                                                        <div class="dd-none">
                                                                            <lv-skeleton primaryColor="#607c8a" secondaryColor="#8aa6b5" :width="300" :height="10"/><br>
                                                                            <lv-skeleton primaryColor="#607c8a" secondaryColor="#8aa6b5" :width="300" :height="10"/><br>
                                                                            <lv-skeleton primaryColor="#607c8a" secondaryColor="#8aa6b5" :width="300" :height="10"/>
                                                                        </div>

                                                                        <br> 

                                                                        <div class="mm-none">
                                                                            <lv-skeleton primaryColor="#607c8a" secondaryColor="#8aa6b5" :width="650" :height="400"/>
                                                                        </div>

                                                                        <div class="dd-none">
                                                                            <lv-skeleton primaryColor="#607c8a" secondaryColor="#8aa6b5" :width="300" :height="300"/>
                                                                        </div>

                                                                        <br> 
                                                                        
                                                                    </div>
                                                                </div>

                                                                <div class="card hp-card-4" v-else>
                                                                    <div class="card-body" >

                                                                        <div class="row">

                                                                            <div class="col">

                                                                                <i class="hp-text-color-dark-0 ri-2x ri-more-line" style="position: absolute; top: 24px; right: 20px; cursor: pointer;" data-bs-toggle="dropdown" ></i>

                                                                                <ul class="dropdown-menu " style="cursor: pointer;">

                                                                                    <li @click="copy(post.id)" class="toast-btn" data-id="liveToast" id="liveToastBtn">
                                                                                        <div class="dropdown-item " style="display: flex; justify-content: center; align-items: center;" >

                                                                                            <span class="submenu-item-icon">
                                                                                                <i class="hp-text-color-dark-0 ri-2 ri-file-copy-line" style="font-size: 20px;"></i>
                                                                                            </span>

                                                                                            <span style="text-align: start; width: 100%; padding-right: 50px; margin-top: -7px; margin-left: 10px;">Copy link</span>
                                                                                        </div>
                                                                                    </li>

                                                                                    <li >
                                                                                        <div class="dropdown-item " style="display: flex; justify-content: center; align-items: center;" @click="sharePost(post.id)"> 
                                                                                            <span class="submenu-item-icon">
                                                                                                <i class="hp-text-color-dark-0 ri-2 ri-share-line" style="font-size: 20px;"></i>
                                                                                            </span>
                                                                                            
                                                                                            <span style="text-align: start; width: 100%; padding-right: 50px; margin-top: -6px; margin-left: 10px;">Share</span>
                                                                                        </div>
                                                                                    </li>

                                                                                    <li>
                                                                                        <hr class="dropdown-divider">
                                                                                    </li>

                                                                                    <li data-bs-toggle="modal" data-bs-target="#reportModal" @click="reportClick(post.id)">
                                                                                        <div class="dropdown-item text-danger"
                                                                                            style="display: flex; justify-content: center; align-items: center;">
                                                                                            <span class="submenu-item-icon">
                                                                                                <i class="hp-text-color-dark-0 ri-2 ri-flag-2-line"
                                                                                                    style="font-size: 20px;"></i>
                                                                                            </span>

                                                                                            <span
                                                                                                style="text-align: start; width: 100%; padding-right: 50px; margin-top: -6px; margin-left: 10px;">Report</span>
                                                                                        </div>
                                                                                    </li>


                                                                                </ul>

                                                                                <div class="row align-items-center" >
                                                                                    <div class="w-auto px-0">
                                                                                        <div class="avatar-item bg-primary-4 d-flex align-items-center justify-content-center rounded-circle" style="width: 48px; height: 48px; ">
                                                                                            <img :src="post.profilePic"  class="hp-img-cover" style="width: 48px; height: 48px; background-color: black; object-fit: cover;  border-color: #b2bec3; border-width: 1px; border-style: solid; ">
                                                                                        </div>
                                                                                    </div>

                                                                                    <div class="w-auto ms-8 px-0 mt-12">
                                                                                        <span class="d-block hp-text-color-black-100 hp-text-color-dark-0 hp-p1-body lh-1 titleM" >{{ post.fullName }} 
                                                                                            <!-- <span>
                                                                                                <img src="@/assets/img/check-circle.png" alt="" width="15px"> 
                                                                                            </span>  -->
                                                                                        </span>
                                                                                        <p class="hp-badge-text fw-normal hp-text-color-dark-30 mt-4">@{{ post.userName }}</p>
                                                                                    </div>
                                                                                </div>
                                                                            </div>

                                                                            <p v-if="post.previewUrl == ''" style="margin-top: 30px; margin-bottom: -5px;">{{ post.caption }}</p>
                                                                            <p v-else style="margin-top: 10px; margin-bottom: -5px;">{{ post.caption }}</p>

                                                                            

                                                                        </div>

                                                                    </div>

                                                                    <div style="width: 100%; height: 100%; ">

                                                    <!-- <div v-if="post.mediaList.length > 0" style="width: 100%; height: 100%; position: absolute; top: 0; border-radius: 0px;" class="card-overlay"></div> -->

                                                    <div v-if="post.isSubscribed || post.isOwner"
                                                        style="cursor: pointer; ">

                                                        <div v-if="post.mediaList.length > 0"
                                                            style=" color: #fff; width: 100%; height: 100%; background-color: transparent;"
                                                            @click="post.toggler = !post.toggler">

                                                            <!-- 1  -->
                                                            <div v-if="post.mediaList.length == 1"
                                                                style="width: 100%; height: 400px; background-color: #9146ff;">

                                                                <img v-if="post.mediaList[0].type.startsWith('image')"
                                                                    :src="post.mediaList[0].url" alt="baesnap"
                                                                    style=" width: 100%; height: 400px; object-fit: cover; ">

                                                                <div v-else >

                                                                    <video 
                                                                    style="height: 400px; width: 100%; object-fit: cover; pointer-events: none; background-color: #b2bec3; ">
                                                                        <source :src="post.mediaList[0].url"
                                                                            type="video/mp4">
                                                                        <source :src="post.mediaList[0].url"
                                                                            type="video/ogg">
                                                                        <source :src="post.mediaList[0].url"
                                                                            type="video/webm">
                                                                        <source :src="post.mediaList[0].url"
                                                                            type="video/3gp">
                                                                        <source :src="post.mediaList[0].url"
                                                                            type="video/quicktime">
                                                                        Your browser does not support the video tag.

                                                                    </video>

                                                                    <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 50%;">
                                                                        <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                    </div>

                                                                </div>
                                                                
                                                            </div>

                                                            <!-- 2 -->
                                                            <div class="d-flex justify-content-center align-items-center"
                                                                v-else-if="post.mediaList.length == 2"
                                                                style=" width: 100%;  height: 400px;">

                                                                <div style="margin-right: 5px; width: 50%;">

                                                                    <img v-if="post.mediaList[0].type.startsWith('image')"
                                                                        :src="post.mediaList[0].url" alt="baesnap"
                                                                        style=" height: 400px; width: 100%; object-fit: cover; ">

                                                                    <div v-else >

                                                                        <video
                                                                        style="height: 400px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/mp4">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/ogg">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/webm">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/3gp">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/quicktime">
                                                                            Your browser does not support the video tag.

                                                                        </video>

                                                                        <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 50%; right: 25%;">
                                                                            <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                        </div>

                                                                    </div>

                                                                    

                                                                    

                                                                </div>

                                                                <div style="width: 50%;">

                                                                    <img v-if="post.mediaList[1].type.startsWith('image')"
                                                                        :src="post.mediaList[1].url" alt="baesnap"
                                                                        style=" height: 400px; width: 100%; object-fit: cover; ">

                                                                    <div v-else>

                                                                        <video  
                                                                        style="height: 400px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                            <source :src="post.mediaList[1].url"
                                                                                type="video/mp4">
                                                                            <source :src="post.mediaList[1].url"
                                                                                type="video/ogg">
                                                                            <source :src="post.mediaList[1].url"
                                                                                type="video/webm">
                                                                            <source :src="post.mediaList[1].url"
                                                                                type="video/3gp">
                                                                            <source :src="post.mediaList[1].url"
                                                                                type="video/quicktime">
                                                                            Your browser does not support the video tag.

                                                                        </video>

                                                                        <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 50%; left: 25%;">
                                                                            <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                        </div>

                                                                    </div>

                                                                    

                                                                </div>

                                                            </div>

                                                            <!-- 3 -->
                                                            <div class="d-flex justify-content-center align-items-center"
                                                                v-else-if="post.mediaList.length == 3"
                                                                style=" width: 100%; height: 550px;">

                                                                <div style="margin-right: 5px; width: 50%;">

                                                                    <img v-if="post.mediaList[0].type.startsWith('image')"
                                                                        :src="post.mediaList[0].url" alt="baesnap"
                                                                        style=" height: 550px; width: 100%; object-fit: cover; ">

                                                                    <div v-else>

                                                                        <video 
                                                                        style="height: 550px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/mp4">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/ogg">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/webm">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/3gp">
                                                                            <source :src="post.mediaList[0].url"
                                                                                type="video/quicktime">
                                                                            Your browser does not support the video tag.

                                                                        </video>

                                                                        <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 50%; top: 50%; ">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                        </div>

                                                                    </div>

                                                                </div>

                                                                <div style="width: 50%;">

                                                                    <div style="width: 100%; height: 275px; padding-bottom: 5px;">

                                                                        <img v-if="post.mediaList[1].type.startsWith('image')"
                                                                            :src="post.mediaList[1].url" alt="baesnap"
                                                                            style=" height: 100%; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video
                                                                            style="height: 100%; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 50%;  top: 33%; ">
                                                                                    <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                    <div style="width: 100%; height: 275px">

                                                                        <img v-if="post.mediaList[2].type.startsWith('image')"
                                                                            :src="post.mediaList[2].url" alt="baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 50%;  bottom: 23%; ">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                </div>

                                                            </div>

                                                            <!-- 4 -->
                                                            <div class="d-flex justify-content-center align-items-center"
                                                                v-else-if="post.mediaList.length == 4"
                                                                style=" width: 100%; height: 550px;">

                                                                <div style="width: 50%; margin-right: 5px; ">

                                                                    <div style="margin-bottom: 5px; position: relative;">

                                                                        <img v-if="post.mediaList[0].type.startsWith('image')"
                                                                            :src="post.mediaList[0].url" alt="baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                    <div style="position: relative;">

                                                                        <img v-if="post.mediaList[1].type.startsWith('image')"
                                                                            :src="post.mediaList[1].url" alt="baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video 
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                </div>

                                                                <div style="width: 50%;">

                                                                    <div style="margin-bottom: 5px; position: relative;">

                                                                        <img v-if="post.mediaList[2].type.startsWith('image')"
                                                                            :src="post.mediaList[2].url" alt="baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video 
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                    <div style="position: relative;">

                                                                        <img v-if="post.mediaList[3].type.startsWith('image')"
                                                                            :src="post.mediaList[3].url" alt="baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video 
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[3].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[3].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[3].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[3].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[3].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>

                                                                    </div>

                                                                </div>

                                                            </div>

                                                            <!-- more -->
                                                            <div class="d-flex justify-content-center align-items-center"
                                                                v-else-if="post.mediaList.length > 4"
                                                                style=" width: 100%; height: 550px;">

                                                                <div style="width: 50%; margin-right: 5px;">

                                                                    <div style="margin-bottom: 5px; position: relative;">

                                                                        <img v-if="post.mediaList[0].type.startsWith('image')"
                                                                            :src="post.mediaList[0].url" alt="baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[0].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>

                                                                    </div>

                                                                    <div style="position: relative;">

                                                                        <img v-if="post.mediaList[1].type.startsWith('image')"
                                                                            :src="post.mediaList[1].url" alt="baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video 
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[1].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                </div>

                                                                <div style="width: 50%;">

                                                                    <div style="margin-bottom: 5px; position: relative;">

                                                                        <img v-if="post.mediaList[2].type.startsWith('image')"
                                                                            :src="post.mediaList[2].url" alt="baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <div v-else>

                                                                            <video
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/mp4">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/ogg">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/webm">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/3gp">
                                                                                <source :src="post.mediaList[2].url"
                                                                                    type="video/quicktime">
                                                                                Your browser does not support the video tag.

                                                                            </video>

                                                                            <div class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 33%;">
                                                                                <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 70px; height: 70px;">
                                                                            </div>

                                                                        </div>


                                                                    </div>

                                                                    <div style="position: relative;">

                                                                        <img v-if="post.mediaList[3].type.startsWith('image')"
                                                                            :src="post.mediaList[3].url" alt="baesnap"
                                                                            style=" height: 275px; width: 100%; object-fit: cover; ">

                                                                        <video v-else controls
                                                                            style="height: 275px; width: 100%; object-fit: cover; pointer-events: none;">
                                                                            <source :src="post.mediaList[3].url"
                                                                                type="video/mp4">
                                                                            <source :src="post.mediaList[3].url"
                                                                                type="video/ogg">
                                                                            <source :src="post.mediaList[3].url"
                                                                                type="video/webm">
                                                                            <source :src="post.mediaList[3].url"
                                                                                type="video/3gp">
                                                                            <source :src="post.mediaList[3].url"
                                                                                type="video/quicktime">
                                                                            Your browser does not support the video tag.

                                                                        </video>

                                                                        <div style="width: 100%; height: 100%; position: absolute; top: 0%;  border-radius: 0px; color: #fff;"
                                                                            class="card-overlay d-flex justify-content-center align-items-center">

                                                                            <h1 style="color: #fff;"> + {{
                                                                                post.mediaList.length - 4 }}</h1>

                                                                        </div>


                                                                    </div>

                                                                </div>

                                                            </div>

                                                        </div>

                                                        <div v-else>

                                                            <img v-if="post.previewUrl != ''" :src="post.previewUrl"
                                                                alt=""
                                                                style=" width: 100%; height: 400px; object-fit: cover; "
                                                                @click="post.toggler = !post.toggler">

                                                        </div>

                                                        <FsLightbox
                                                            :toggler="post.toggler" :sources="post.urlList" ></FsLightbox>

                                                        

                                                    </div>

                                                    <div v-else style="position: relative; width: 100%"
                                                        class="d-flex justify-content-center align-items-center">

                                                        <img v-if="post.previewUrl != ''" :src="post.previewUrl" alt=""
                                                            style=" width: 100%; height: 400px; object-fit: cover; cursor: pointer;"
                                                            @click="post.toggler = !post.toggler">

                                                        <div v-if="post.previewUrl != '' && post.mediaList.length > 0"
                                                            style=" width: 95%; color: #fff; border-radius: 5px; border-width: 1px; border-style: dashed; border-color: #9146ff; padding: 20px 10px 20px 10px;  position: absolute; bottom: 10px; flex-direction: column;"
                                                            class=" d-flex justify-content-center align-items-center card-overlay">

                                                            <div
                                                                class=" d-flex justify-content-center align-items-center ">

                                                                <button v-if="post.imgCount > 0"
                                                                    style="margin-bottom: 20px; background-color: transparent"
                                                                    class="btn btn-text text-white">
                                                                    <i class="iconly-Light-Image"></i>
                                                                    <span style="padding-left: 5px;">{{ post.imgCount }}
                                                                        Images</span>
                                                                </button>

                                                                <button v-if="post.vidCount > 0"
                                                                    style="margin-bottom: 20px; background-color: transparent"
                                                                    class="btn btn-text text-white">
                                                                    <i class="iconly-Light-Video"></i>
                                                                    <span style="padding-left: 5px;">{{ post.vidCount }}
                                                                        Videos</span>
                                                                </button>

                                                            </div>

                                                            <button @click="subClick2(post)" class="btn btn-primary"
                                                                
                                                                style="width: 90%; margin-bottom: 20px;">
                                                                <i class="iconly-Light-Lock"></i>
                                                                <span style="padding-left: 5px;">Subscribe to unlock
                                                                    post</span>
                                                            </button>
                                                        </div>

                                                        <FsLightbox :toggler="post.toggler" :sources='post.previewUrl2' />

                                                        

                                                    </div>

                                                                    </div>

                                                                    <div style="width: 100%; display: flex; justify-content: space-between; align-items: center; padding: 20px;">

                                                                        <div  style="display: flex; justify-content: center; align-items: center;">

                                                                            <div >

                                                                                <div v-if="post.isLiked" :id="post.idD+'like'" @click="likeClick(post.idD+'like', index, post)" class="d-flex w-auto lh-1 hp-wish-button hp-cursor-pointer rounded-circle remix-icon p-8 text-danger bg-danger-4 hp-bg-color-dark-danger">
                                                                                    <i class=" iconly-Light-Heart2"></i>
                                                                                </div>

                                                                                <div v-else :id="post.idD+'like'" @click="likeClick(post.idD+'like', index, post)" class="d-flex w-auto lh-1 hp-wish-button hp-cursor-pointer rounded-circle remix-icon p-8 text-black-40 hp-text-color-dark-70 bg-black-10 hp-bg-color-dark-90">
                                                                                    <i class=" iconly-Light-Heart2"></i>
                                                                                </div>

                                                                            </div>

                                                                            <span style="margin-left: 5px; width: 40px; font-weight: 600;" class="hp-badge-text">
                                                                                {{ post.likeCount }}
                                                                            </span>

                                                                            <div v-if="post.isBookmarked" :id="post.idD+'book'" @click="bookClick(post.idD+'book', index, post)" class="d-flex w-auto lh-1 hp-book-button hp-cursor-pointer rounded-circle remix-icon p-8 text-primary bg-primary-4 hp-bg-color-dark-primary">
                                                                                <i class="hp-text-color-dark-0 iconly-Light-Bookmark"></i>
                                                                            </div>

                                                                            <div v-else :id="post.idD+'book'" @click="bookClick(post.idD+'book', index, post)" class="d-flex w-auto lh-1 hp-book-button hp-cursor-pointer rounded-circle remix-icon p-8 text-black-40 hp-text-color-dark-70 bg-black-10 hp-bg-color-dark-90">
                                                                                <i class="hp-text-color-dark-0 iconly-Light-Bookmark"></i>
                                                                            </div>

                                                                            <span style="margin-left: 5px; width: 40px; font-weight: 600;" class="hp-badge-text">
                                                                                {{ post.bookmarkCount }}
                                                                            </span>

                                                                            <div v-if="post.commentCount > 0" @click="commentClick(post, index)" data-bs-toggle="modal" data-bs-target="#comments"  class="d-flex w-auto lh-1 hp-book-button hp-cursor-pointer rounded-circle remix-icon p-8 text-dark bg-dark-4 bg-black-10 hp-bg-color-dark-90">
                                                                                <i class="hp-text-color-dark-0 iconly-Light-Chat hp-cursor-pointer "></i>
                                                                            </div>

                                                                            <div v-else @click="commentClick(post, index)" data-bs-toggle="modal" data-bs-target="#comments"  class="d-flex w-auto lh-1 hp-book-button hp-cursor-pointer rounded-circle remix-icon p-8 text-black-40 hp-text-color-dark-70 bg-black-10 hp-bg-color-dark-90">
                                                                                <i class="hp-text-color-dark-0 iconly-Light-Chat hp-cursor-pointer "></i>
                                                                            </div>

                                                                            

                                                                            <span style="margin-left: 5px; width: 40px; font-weight: 600;" class="hp-badge-text">
                                                                                {{ post.commentCount }}
                                                                            </span>

                                                                        </div>

                                                                        <div>

                                                                            <button class="btn btn-icon-only rounded-circle btn-danger btn-sm" @click="deleteClick(post)" data-bs-toggle="modal" data-bs-target="#delete">
                                                                                <i class="hp-text-color-dark-0 iconly-Light-Delete"></i>
                                                                            </button>

                                                                        </div>

                                                                    </div>
                                                                    
                                                                    <!-- end -->
                                                                </div>

                                                            </div>

                                                            <div style="width:100%; display: flex; justify-content: center; align-items: center;" id="emptyPost2">

                                                                <InfiniteLoading @infinite="handleInfinite" class="spinner">
                                                                    
                                                                </InfiniteLoading>

                                                            </div>

                                                            <div style="margin-top: 200px; margin-bottom: 400px; display: flex; justify-content: center; align-items: center; flex-direction: column;" id="emptyPost">
                                                                <p class="hp-badge-text">No posts yet...</p>
                                                            </div>

                                                        </div>

                                                        <!-- MEDIA -->
                                                        <div class="tab-pane fade" id="media" role="tabpanel" aria-labelledby="media-tab" style="overflow: hidden;">
                                                            
                                                            <div class="row g-8">

                                                                <div class="col-6 col-xl-3" style="margin-bottom: 10px;" v-for="(post, index) in postsMediaList" :key="'number'+index">
                                                                
                                                                <div class="card hp-card-" style="height: 150px !important; border-radius: 10px;">
                                                                    <div class="card-bod" >

                                                                        <div style="width: 100%; height: 100%;">

                                                                            <!-- <div v-if="post.mediaList.length > 0" style="width: 100%; height: 100%; position: absolute; top: 0; border-radius: 0px;" class="card-overlay"></div> -->

                                                                            <div style="cursor: pointer; ">

                                                                                <img :src="post.url" alt="" v-if="post.type == 'image'" style="object-fit: cover; width: 100%; height: 150px; border-radius: 10px;" @click="post.toggler = !post.toggler">

                                                                                <div v-else >

                                                                                    <video 
                                                                                    style="height: 150px; width: 100%; object-fit: cover; pointer-events: none; border-radius: 10px; background-color: #b2bec3; " >
                                                                                        <source :src="post.url"
                                                                                            type="video/mp4">
                                                                                        <source :src="post.url"
                                                                                            type="video/ogg">
                                                                                        <source :src="post.url"
                                                                                            type="video/webm">
                                                                                        <source :src="post.url"
                                                                                            type="video/3gp">
                                                                                        <source :src="post.url"
                                                                                            type="video/quicktime">
                                                                                        Your browser does not support the video tag.

                                                                                    </video>

                                                                                    <div @click="post.toggler = !post.toggler" class="position-absolute d-flex justify-content-center align-items-center" style="width: 100%; top: 35%;">
                                                                                        <img  src="@/assets/img/playVid.png" alt="" style=" cursor: pointer; width: 50px; height: 50px;">
                                                                                    </div>

                                                                                </div>

                                                                                

                                                                            </div>

                                                                            

                                                                        </div>

                                                                    </div>

                                                                    

                                                                </div>

                                                                <FsLightbox :toggler="post.toggler" :sources="post.urlList" ></FsLightbox>
                                                                <!--end-->
                                                                </div>

                                                                <div style="width:100%; display: flex; justify-content: center; align-items: center;" id="emptyMedia2">

                                                                    <InfiniteLoading @infinite="handleInfinite2" class="spinner">
                                                                        
                                                                    </InfiniteLoading>

                                                                </div>

                                                                <div style="margin-top: 200px; margin-bottom: 400px; display: flex; justify-content: center; align-items: center; flex-direction: column;" id="emptyMedia">
                                                                    <p class="hp-badge-text">No media yet...</p>
                                                                </div>

                                                            </div>

                                                        </div>

                                                    </div>

                                                </div>

                                            </div>

                                        </div>

                                    </div>

                                </div>

                            </div>

                            <!-- SETTINGS -->
                            <SettingsBody/>
                            
                        </div>

                    </div>

                    
                </div>

                <!-- FOOTER -->
                <FooterBody/>

            </div>

        </div>

    </main>

    <!-- SCROLL TO TOP -->
    <div class="scroll-to-top">
        <button type="button" class="btn btn-primary btn-icon-only rounded-circle hp-primary-shadow">
            <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="16px" width="16px" xmlns="http://www.w3.org/2000/svg">
                <g>
                    <path fill="none" d="M0 0h24v24H0z"></path>
                    <path d="M13 7.828V20h-2V7.828l-5.364 5.364-1.414-1.414L12 4l7.778 7.778-1.414 1.414L13 7.828z"></path>
                </g>
            </svg>
        </button>
    </div>

        <!-- SUCCESS -->
        <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg" ref="successModal">
            <div class="col-12 col-xl-4" style="width: 300px; ">
                <div class="card hp-card-4" >
                    <div class="card-body" >
                        <div class="row" >
                            <div class="col-12 text-center">
                                <img src="@/assets/img/successImg.png" alt="Upgrade Account" class="hp-block mx-auto" style=" width: 200px; padding-top: 10px;">

                                <h5 class="mt-24 mb-16 me-4 ">Success!</h5>
                                <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{successText}}</p>

                                <button class="btn btn-sm btn-primary" style="color: #ffffff; font-weight: 500; border-style: none; margin-top: 25px; margin-bottom: 10px;" @click="closeS">Okay</button>

                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- ERROR -->
        <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg " ref="errorModal">

            <div class="col-12 col-xl-4" style="width: 300px;">
                <div class="card hp-card-6">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 text-center">
                                <img src="@/assets/img/errorImg.png" alt="Upgrade Account" class="hp-block mx-auto" style=" width: 200px; padding-top: 30px;">

                                <h5 class="mt-24 mb-16 me-4 text-danger" >Error!</h5>
                                <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{errorText}} </p>

                                <button class="btn btn-sm btn-primary" style="color: #ffffff; font-weight: 500; border-style: none; margin-top: 20px; margin-bottom: 10px;" @click="closeE">Okay</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <!-- LOADING -->
        <div style=" display: flex; justify-content: center; align-items: center;  z-index: 999999;" class="loadingModalBg" ref="loadingModal">
            <div class="col-12 col-xl-4" style="width: 300px;">
                <div class="card hp-card-6">
                    <div class="card-body">
                        <div class="row">

                            <div class="col-12 text-center">
                                <img src="@/assets/img/loadingImg.png" style="width: 200px; padding-top: 20px;" >
                            </div>

                            <div class="col-12 text-center">
                                <h5 class="mt-24 mb-16 me-4 ">Please wait...</h5>
                                <p class="hp-p1-body mb-0" style="margin-top: -10px;">{{loadingText}} </p>

                                <img src="@/assets/img/loading.gif" alt="" style="width: 60px; margin-top: 20px;">
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- EditPROFILE -->
        <div class="modal fade" id="editProfile" tabindex="-1" aria-labelledby="editProfileLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered ">
                <div class="modal-content" >
                    <div class="modal-heade">
                        
                        
                        <div style="display: flex; justify-content: space-between; align-items: center; width: 100%; padding: 20px;">
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            <h4 class="modal-title">Edit profile</h4>
                            
                            <button @click="saveInfo" class="btn btn-sm btn-primary">Save</button>
                        </div>

                        
                    </div>

                    <div class="modal-body" style="margin-top: -20px;">

                        <div>

                            <div style="width: 100%; height: 120px; ">

                                <img :src="profileBack" id="profileBack" alt="" style="width: 100%; height: 100%; object-fit: cover; border-top-left-radius: 10px; border-top-right-radius: 10px;">

                                <input @change="profileBackPreview" type="file" class="form-control" accept="image/*" hidden id="profileBackSelect"  >
                                <label for="profileBackSelect" class="form-label" style="cursor: pointer; color: #fff; margin-top: -100px; margin-left: -170px; ">
                                    <i class="hp-text-color-dark-0 iconly-Light-Camera" style="color: #fff; background-color: #9146ff; border-radius: 50%; padding: 5px; "></i>
                                </label>

                            </div>

                            <div  style="margin-top: -50px;">
                                <img :src="profilePic" id="profilePic" alt="" style="border-radius: 50%; width: 100px; height: 100px; object-fit: cover; border-color: #000; border-width: 1px; border-style: solid; margin-left: 10px; margin-top: 0px;">

                                
                                

                            </div>

                            <div class="mb-24" style="margin-left: 45px; margin-top: -15px;">

                                <input @change="profilePicPreview" type="file" class="form-control btn btn-icon-only rounded-circle btn-primary" accept="image/*" hidden id="profilePicSelect"  >
                                <label for="profilePicSelect" class="form-label" style="cursor: pointer; color: #fff;  ">
                                    <i class="hp-text-color-dark-0 iconly-Light-Camera" style="color: #fff; background-color: #9146ff; border-radius: 50%; padding: 5px; "></i>
                                </label>

                            </div>

                            <div class="mb-24">
                                <label for="exampleInputEmail1" class="form-label">Username</label>
                                <div class="input-group mb-16">
                                    <span class="input-group-text" id="basic-addon1">@</span>
                                    <input type="text" class="form-control" placeholder="@johnsmith" required v-model="userName">
                                </div>
                                
                            </div>

                            <div class="mb-24">
                                <label for="exampleInputEmail1" class="form-label">Display name</label>
                                <input type="text" class="form-control"  aria-describedby="emailHelp" placeholder="e.g John Smith" required v-model="displayName">
                                
                            </div>

                            <div class="mb-24">

                                <label for="displayName" class="form-label">Bio</label>
                                <textarea name="description"  class="form-control" rows="2" maxlength="200"  placeholder="Tell us about yourself..." v-model="bio"  style="line-height: 20px; padding-top: 10px;" ></textarea>

                            </div>

                            <div class="mb-24">
                                <label for="exampleInputEmail1" class="form-label">Gender</label>
                                <select class="form-select" aria-label="Default select example" v-model="gender">
                                    <option value="">Choose your gender</option>
                                    <option value="male">Male</option>
                                    <option value="female">Female</option>
                                    <option value="trans">Transgender</option>
                                </select>
                                
                            </div>

                            <div class="mb-24">
                                <label for="exampleInputEmail1" class="form-label">Sexuality</label>
                                <select class="form-select" aria-label="Default select example" v-model="sexuality">
                                    <option value="">Choose your sexuality</option>
                                    <option value="straight">Straight</option>
                                    <option value="gay">Gay</option>
                                    <option value="lesbian">Lesbian</option>
                                    <option value="bisexual">Bisexual</option>
                                </select>
                                
                            </div>



                            <div class="mb-24">
                                <label for="exampleInputEmail1" class="form-label">Twitter handle</label>
                                <div class="input-group mb-16">
                                    <span class="input-group-text" id="basic-addon1">https://x.com/</span>
                                    <input type="text" class="form-control" placeholder="Twitter handle" required v-model="twitter">
                                </div>
                                
                            </div>

                            <div class="mb-24">
                                <label for="exampleInputEmail1" class="form-label">Instagram handle</label>
                                <div class="input-group mb-16">
                                    <span class="input-group-text" id="basic-addon1">https://instagram.com/</span>
                                    <input type="text" class="form-control" placeholder="Instagram username" required v-model="instagram">
                                </div>
                                
                            </div>

                            <div class="mb-24">
                                <label for="exampleInputEmail1" class="form-label">TikTok handle</label>
                                <div class="input-group mb-16">
                                    <span class="input-group-text" id="basic-addon1">https://tiktok.com/@</span>
                                    <input type="text" class="form-control" placeholder="TikTok username" required v-model="facebook">
                                </div>
                                
                            </div>

                            <div class="mb-24">
                                <label for="exampleInputEmail1" class="form-label">Snapchat handle</label>
                                <div class="input-group mb-16">
                                    <span class="input-group-text" id="basic-addon1">https://snapchat.com/add/</span>
                                    <input type="text" class="form-control" placeholder="Snapchat username" required v-model="snap">
                                </div>
                                
                            </div>

                            

                            

                            

                            <div class="divider mt-18 mb-16"></div>

                            <div class="modal-footer d-flex justify-content-center">
                                
                                
                            </div>

                        </div>

                  
                    </div>

                    
                </div>
            </div>
        </div>

        <!-- MEDIA GALLERY -->
        <div class="modal fade" id="mediaGallery" tabindex="-1" aria-labelledby="mediaGalleryLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-fullscreen">
                <div class="modal-content">
                    <div class="modal-header">
                        
                        <h5 class="modal-title">Media gallery ( @{{ modelUsername }} )</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>

                    <div class="modal-body" style="margin-top: -30px;">

                        <div v-if="mediaUrl != ''" style="display: flex; justify-content: center; align-items: center; margin-bottom:10px ;">

                                <video controls controlsList="nodownload" oncontextmenu="return false;" v-if="mediaType.startsWith('video')"  class="shm">
                                    <source :src="mediaUrl" type="video/mp4" >
                                    <source :src="mediaUrl" type="video/ogg" >
                                    <source :src="mediaUrl" type="video/webm" >
                                    <source :src="mediaUrl" type="video/3gp" >
                                    <source :src="mediaUrl" type="video/quicktime" >
                                    Your browser does not support the video tag.

                                </video>

                                <img :src="mediaUrl" alt="" v-else class="shm" style="object-fit: cover;">

                                

                        </div>

                        <div class="divider border-black-40 hp-border-color-dark-70 hp-sidebar-hidden mt-0 px-0" ></div>

                        <div class="d-flex align-items-center" style="flex-wrap: wrap;">

                            <!-- dupli img-->
                            <div v-for="(media, index) in mediaList" :key="index" style="position: relative; border-radius: 5px; border-width: 1px; border-color: #b2bec3; margin-right: 10px; padding: 5px; margin-bottom: -5px;">

                                <div v-if="media.type.startsWith('image')" @click="playMedia(media)">
                                    <img :src="media.url" alt="" style="width: 90px; height: 90px; object-fit: cover; border-radius: 5px; cursor: pointer;"  >

                                    <p class="hp-input-description" style="text-align: center; margin-top: 5px;">{{ fileSizeFormat(media.size) }} </p>
                                </div>

                                <div v-else style="position: relative; border-radius: 5px; border-width: 1px; border-color: #b2bec3; margin-right: 10px; padding: 5px; margin-bottom: -5px;">

                                    <div @click="playMedia(media)" >
                                        <video style="width: 90px; height: 90px; border-radius: 5px; object-fit: cover; position: relative;">
                                            <source :src="media.url" type="video/mp4" >
                                            <source :src="media.url" type="video/ogg" >
                                            <source :src="media.url" type="video/webm" >
                                            <source :src="media.url" type="video/3gp" >
                                            <source :src="media.url" type="video/quicktime" >
                                            Your browser does not support the video tag.

                                        </video>

                                        <i  class="hp-text-color-dark-0 position-absolute ri-2x ri-play-circle-fill" style="color: #fff; top: 25%; left: 35%; cursor: pointer;"></i>

                                        <p class="hp-input-description" style="text-align: center; margin-top: 5px;">{{ fileSizeFormat(media.size) }} </p>
                                    </div>

                                </div>

                            </div>

                        </div>



                        
                    </div>
                    
                </div>
            </div>
        </div>

        <!-- SHOW -->
        <div style=" display: flex; justify-content: center; align-items: center;  z-index: 9999;" class="loadingModalBg" ref="showModal">
            <div class="col-12 col-xl-12 shx">
                <div class="card hp-card-6">
                    <div class="card-body" style="position: relative;">

                        <button type="button" class="btn-close hp-bg-none d-flex align-items-center justify-content-center" style="position:absolute; top:10px; right: 10px;" @click="closeShow">
                                <i class="ri-close-line hp-text-color-dark-0 lh-1" style="font-size: 24px;"></i>
                        </button>

                        <div class="row">

                            <h4 style="text-align: center;">{{mediaName}}</h4>

                            <div style="display: flex; justify-content: center; align-items: center;">

                                <video controls v-if="mediaType.startsWith('video')"  class="shm">
                                    <source :src="mediaUrl" type="video/mp4" >
                                    <source :src="mediaUrl" type="video/ogg" >
                                    <source :src="mediaUrl" type="video/webm" >
                                    <source :src="mediaUrl" type="video/3gp" >
                                    <source :src="mediaUrl" type="video/quicktime" >
                                    Your browser does not support the video tag.

                                </video>

                                <img :src="mediaUrl" alt="" class="shm" v-else>

                                

                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- COMMENTS -->
        <div class="modal fade" id="comments" tabindex="-1" aria-labelledby="commentsLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        
                        <h4 class="modal-title">{{ commentCount }} Comments</h4>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" style="z-index: 5;"></button>
                    </div>

                    <div class="divider border-black-40 hp-border-color-dark-70 hp-sidebar-hidden mt-0 px-0" ></div>

                    <div class="modal-body" style="margin-top: -25px;">

                        <div id="comDiv"></div>

                        <div class="col-12" v-for="(com, index) in comments" :key="index">

                            <div class="row">
                                <div class="col-12" style="margin-bottom: 20px;" >
                                    <div style="justify-content: flex-start; display: flex; align-items: flex-start; width: 100%;">
                                        <div class="w-auto px-0" @click="profileClick(com.userId, com.userName)" style="cursor: pointer;" data-bs-dismiss="modal">
                                            <div class="avatar-item bg-primary-4 d-flex align-items-center justify-content-center rounded-circle" style="width: 38px; height: 38px; ">
                                                <img :src="com.profilePic"  class="hp-img-cover" style="width: 38px; height: 38px; background-color: black; object-fit: cover; ">
                                            </div>
                                        </div>

                                        <div class="w-auto ms-8 px-0 mt-4" style="width: 100%;">
                                            <p class="d-block hp-text-color-black-100 hp-text-color-dark-0 hp-p1-body lh-1 mt-4 titleM" style="font-size: 14px;"> {{ com.name }}  </p>
                                            <p style="font-size: 12px; margin-top: -5px; width: 100%; word-break: break-all;" class=" fw-normal hp-text-color-dark-30"> {{ com.comment }} </p>

                                            <p style="font-size: 9px; font-style: italic;" class="hp-badge-text fw-normal hp-text-color-dark-30 mt-4">{{ com.date }}</p>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>

                        <div v-if="commentCount == 0" style="margin-top: 50px; margin-bottom: 50px; display: flex; justify-content: center; align-items: center; flex-direction: column;" >
                            <p class="hp-badge-text">No comments yet...</p>
                        </div>

                        <div v-if="commentCount > 20" style="margin-top: 0px; margin-bottom: 50px; display: flex; justify-content: center; align-items: center; flex-direction: column;" >
                            <button data-bs-dismiss="modal" class="btn btn-sm btn-primary" @click="postClick(postId)">Load more</button>
                        </div>

                    
                    </div>

                    <form @submit.prevent="postComment" style="width: 100%; padding: 20px;">

                        <div
                            style="display: flex; justify-content: center; align-items: center; width: 100%; margin-top: 0px;">

                            <div style="width: 100%; margin-right: 10px;">

                                <textarea style="line-height: 20px; padding-top: 10px;" name="description"
                                    v-model="commentInput" maxlength="300" class="form-control" rows="3"
                                    placeholder="Type comment here..." required></textarea>
                            </div>

                            <button class="btn btn-sm btn-icon-only rounded-circle btn-primary" id="commentBtn">
                                <i class="hp-text-color-dark-0 iconly-Light-Send"></i>
                            </button>

                            <!-- <button class="btn btn-sm btn-primary" style="color: #fff;" >Send</button> -->

                        </div>

                    </form>

                    
                </div>
            </div>
    </div>

        <!-- DELETE -->
        <div class="modal fade" id="delete" tabindex="-1" aria-labelledby="deleteLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-sm">
                <div class="modal-content">
                    <div class="modal-header">
                        
                        <h4 class="modal-title">Delete post</h4>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>

                    

                    <div class="modal-body" style="margin-top: -30px;">

                        <p class="hp-p1-body"> Are you sure you want to permanently delete this post? All media files attached to this post will be deleted as well  </p>
                        
                    </div>

                    <div class="modal-footer">
                        <button type="button" class="btn btn-text" data-bs-dismiss="modal">Close</button>
                        <button type="button" class="btn btn-danger" @click="deletePost" data-bs-dismiss="modal">Delete</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- COPY TOAST -->
        <div class="position-fixed bottom-0 end-0 p-16" style="z-index: 99">
            <div data-id="liveToast" class="toast" role="alert" aria-live="assertive" aria-atomic="true" id="toastDiv" style="background-color: #e8def7; padding: 10px;">
                <div class="toast-header" style="background-color: #e8def7;">
                    
                    <strong class="me-auto">Baesnap</strong>
                    <small>1 second ago</small>
                    <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>
                </div>

                <div class="toast-body">
                    {{toastMessage}}
                </div>
            </div>
        </div>

        <!-- REPORT -->
        <div class="modal fade" id="reportModal" tabindex="-1" aria-labelledby="reportModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="centeredBackdropLabel">Report</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>

                    <div class="modal-body">
                        <form @submit.prevent="report">

                            <div class="form-check">
                                <input class="form-check-input" type="radio" name="reportReason" id="reportReason1" checked v-model="reportReason" value="Violates Baesnap Terms of Service">
                                <label class="form-check-label" for="reportReason1">
                                    Violates Baesnap Terms of Service
                                </label>
                            </div>

                            <div class="form-check" style="margin-top: 10px;">
                                <input class="form-check-input" type="radio" name="reportReason" id="reportReason2" v-model="reportReason" value="Contains copyrighted material (DMCA)">
                                <label class="form-check-label" for="reportReason2">
                                    Contains copyrighted material (DMCA)
                                </label>
                            </div>

                            <div class="form-check" style="margin-top: 10px;">
                                <input class="form-check-input" type="radio" name="reportReason" id="reportReason3" v-model="reportReason" value="Child Sexual Abuse Material (CSAM)">
                                <label class="form-check-label" for="reportReason3">
                                    Child Sexual Abuse Material (CSAM)
                                </label>
                            </div>

                            <div class="form-check" style="margin-top: 10px;">
                                <input class="form-check-input" type="radio" name="reportReason" id="reportReason4" v-model="reportReason" value="Report Spam">
                                <label class="form-check-label" for="reportReason4">
                                    Report Spam
                                </label>
                            </div>

                            <div class="form-check" style="margin-top: 10px;">
                                <input class="form-check-input" type="radio" name="reportReason" id="reportReason5" v-model="reportReason" value="Report Abuse">
                                <label class="form-check-label" for="reportReason5">
                                    Report Abuse
                                </label>
                            </div>

                            <div class="mb-24" style="margin-top: 30px;">
                                <label for="orderDetails" class="form-label"> Message <span class="text-danger me-4">*</span> </label>
                                <textarea name="orderDetails" id="orderDetails" class="form-control" rows="4" placeholder="Type here..." maxlength="300" required v-model="reportMessage" style="line-height: 20px; padding: 10px;"></textarea>
                            </div>

                            <div class="modal-footer">
                                <button type="button" class="btn btn-text" data-bs-dismiss="modal">Close</button>
                                <button type="submit" class="btn btn-primary" data-bs-dismiss="modal">Report</button>
                            </div>

                            
                        </form>
                    </div>

                    
                </div>
            </div>
        </div>

</template>

<style scoped>

    .shx{
        width: 1000px;   
    }

    .shm{
        max-width: 100%;
        max-height: 500px;
        object-fit: cover;
    }

    .no-pad{
        margin-top: -15px;
    }

    .profB{
        border-top-left-radius: 20px; 
        border-top-right-radius: 20px;
    }

    @media only screen and (max-width: 666px){

        .shx{
            width: 350px;
            
        }

        .shm{
            max-width: 100%;
            max-height: 700px;
            object-fit: cover;
        }

        .no-pad{
            margin: 0;
            padding: 0;
        }

        .profB{
            border-radius: 0px; 
        
        }

    }

</style>

<script>

    import SidebarBody from '@/components/SidebarBody.vue';
    import SettingsBody from '@/components/SettingsBody.vue';
    import HeaderBody from '@/components/HeaderBody.vue';
    import FooterBody from '@/components/FooterBody.vue';
    import InfiniteLoading from '../../node_modules/v3-infinite-loading/lib/v3-infinite-loading.es';
    import "../../node_modules/v3-infinite-loading/lib/style.css";
    import FsLightbox from "fslightbox-vue";
    import LvSkeleton from "lightvue/skeleton";
    import LvCodeLoader from 'lightvue/skeleton/preset/CodeLoader';

    import TimeAgo from 'javascript-time-ago';
    import en from 'javascript-time-ago/locale/en';
    import Compressor from 'compressorjs';

    import { doc, addDoc, collection, query, where, getDoc, getDocs, updateDoc, arrayUnion, serverTimestamp, orderBy, deleteDoc, increment, limit, startAfter, arrayRemove, setDoc } from "firebase/firestore"; 
    import { getStorage, ref, uploadBytesResumable, getDownloadURL, deleteObject } from "firebase/storage";
    import {getAuth, onAuthStateChanged, signOut} from "firebase/auth"
    import { db } from '@/firebase';

    export default {

        components: {
            SidebarBody,
            SettingsBody,
            HeaderBody,
            FooterBody,
            InfiniteLoading,
            FsLightbox,
            LvSkeleton,
            LvCodeLoader,
        },

        data(){
            return{

                loadingText:"",
                errorText: "",
                successText: "",

                lastDocSnapshot: null,
                lastDocSnapshot2: null,

                profileBack: "",
                profilePic: "",
                userName: "",
                displayName: "",
                phone: "",
                bio: "",
                gender: "",
                sexuality: "",
                email: "",
                facebookLink: "",
                instagramLink: "",
                twitterLink: "",
                snapLink: "",

                postCount: "",
                mediaCount: "",

                twitter:"",
                instagram: "",
                facebook:"",
                snap:"",

                fanCount: "",
                followersCount: "",
                followingCount: "",
                likes: "",
                userType: "",

                postsList: [],
                postsMediaList: [],

                modelUsername: "",
                mediaList: "",
                mediaName: "",
                mediaSize: "",
                mediaType: "",
                mediaUrl: "",

                commentPic: "",
                commentCount: "",
                comments: [],
                commentInput: "",
                postIndex: "",

                likeSpamList:[],
                bookSpamList:[],

                post: "",

                postId: "",
                toastMessage: "",
                reportReason: "Violates Baesnap Terms of Service",
                reportMessage: "",
                rPostId: "",
                reportCount: 0,
                
                videoObserver: null
                

            }
        },

        mounted(){

            document.body.style.overflowY = 'scroll';

            document.getElementById("mobileLogo").style.display= 'none';
            document.getElementById("mobileTitle").textContent = 'Profile';

            
            document.getElementById("moreN").classList.add("active");
            document.getElementById("moreN2").classList.add("active");
            
            this.getUserInfo();

            this.videoObserver = new MutationObserver(() => {
                this.hideDownloadButtons()
            })

            this.videoObserver.observe(document.body, {
                childList: true,
                subtree: true
            })
            
            
        },

        beforeUnmount(){
            if (this.videoObserver) {
                this.videoObserver.disconnect()
            }
        },

        methods:{

            postClick(postId){

                this.$router.push({ name: 'post', params: { id: postId } });
                return;

            },

            hideDownloadButtons() {
                document.querySelectorAll('.fslightbox-container video').forEach(video => {
                    video.setAttribute('controlsList', 'nodownload')
                    video.setAttribute('disablePictureInPicture', '')
                    video.oncontextmenu = () => false
                })
            },

            reportClick(postId){
                this.rPostId = postId;
            },

            showToast(){
                $(".toast").each(function () {
                    let eachItem = $(this), eachItemId = eachItem.data("id");

                    if (eachItemId) {
                        new bootstrap.Toast($(this)).show();
                    }
                });
            },

            async report(){

                    this.reportCount++

                    if(this.reportCount > 4){
                        return;
                    }

                    this.loadingText = "Reporting post";
                    this.$refs.loadingModal.classList.add("bg-active");

                    //add report
                    let mSecs = new Date().getTime() / 1000;
                    let secs = 10000000000 / mSecs;

                    const auth = getAuth();

                    await addDoc(collection(db, "UserReports"), {
                            
                        title: this.reportReason,
                        message: this.reportMessage,
                        postId: this.rPostId,
                        status: "pending",
                        userId: auth.currentUser.uid,
                        fullName: sessionStorage.getItem("fullName"),
                        email: sessionStorage.getItem("email"),
                        username: sessionStorage.getItem("userName"),
                        profilePic: sessionStorage.getItem("profilePic"),
                    });

                    this.toastMessage = "Post reported successfully!";
                    this.$refs.loadingModal.classList.remove("bg-active");
                    this.showToast();

            },

            sharePost(postId){
                    if(navigator.share){
                        navigator.share({
                            text: "Check out my post on Baesnap",
                            url: "https://app.baesnap.com/post/"+postId,
                            title: "Baesnap | Post"
                        })
                    }
                    else{
                            navigator.clipboard.writeText("https://app.baesnap.com/post/"+postId)
                    }
            },

            copy(postId){
                this.toastMessage = "Link copied successfully!"
                let link = "https://app.baesnap.com/post/"+postId;
                navigator.clipboard.writeText(link);
                this.showToast(); 

            },

            closeE(){
                this.$refs.errorModal.classList.remove("bg-active");
            },

            closeS(){
                this.$refs.successModal.classList.remove("bg-active");
                this.$router.go();
            },

            closeShow(){
                this.mediaName = "";
                this.mediaType = "";
                this.mediaUrl = "";
                this.mediaSize = "";
                this.$refs.showModal.classList.remove("bg-active");
                return;
                
            },

            goUserList(){
                this.$router.push({name: "user-lists"});
            },

            fileSizeFormat(fileSize){
                let mSize;
                if (Number(fileSize) >= 1073741824) { 
                        mSize = (Number(fileSize) / 1073741824).toFixed(2) + " GB"; 
                    }
                    else if (Number(fileSize) >= 1048576) { 
                        mSize = (Number(fileSize) / 1048576).toFixed(2) + " MB"; 
                    } 
                    else if (Number(fileSize) >= 1024) { 
                        mSize = (Number(fileSize) / 1024).toFixed(2) + " KB"; 
                    }
                    
                    return mSize;
            },

            kFormatter(num) {
                return Math.abs(num) > 999 ? Math.sign(num)*((Math.abs(num)/1000).toFixed(1)) + 'k' : Math.sign(num)*Math.abs(num);
                
            },

            timeFormat(date){

                let newFormat;

                TimeAgo.addDefaultLocale(en);
                const timeAgo = new TimeAgo('en-US');
                newFormat =  timeAgo.format(Number(date));

                return newFormat;

            },

            getOccurrence(array, value) {
                var count = 0;
                array.forEach((v) => (v === value && count++));
                return count;
            },

            setMeta(){

            },

            copyLink(){
                navigator.clipboard.writeText(String("https://app.baesnap.com/profiles/"+this.userName));
                $('[rel=tooltip]').tooltip();
            },

            share(){
                if(navigator.share){
                    navigator.share({
                        text: this.bio,
                        url: "https://app.baesnap.com/profiles/"+this.userName,
                        title: "Baesnap | "+this.userName
                    })
                }
                else{
                    navigator.clipboard.writeText("https://app.baesnap.com/profiles/"+this.userName)
                }
            },

            async getUserInfo(){

                this.loadingText = "Getting user info...";
                this.$refs.loadingModal.classList.add("bg-active");

                const auth = getAuth();

                const userRef = doc(db, "Users", auth.currentUser.uid);
                const userSnap = await getDoc(userRef);

                if (userSnap.exists()) {
                    this.profileBack = userSnap.data().profileBackground;
                    this.profilePic =  userSnap.data().profilePic;
                    this.displayName = userSnap.data().name;
                    this.userName = userSnap.data().displayId;
                    this.phone = userSnap.data().phone;
                    this.fanCount = userSnap.data().fanCount;
                    this.followersCount =  userSnap.data().followersCount;
                    this.followingCount =  userSnap.data().followingCount;
                    this.likes = userSnap.data().likes;
                    this.userType = userSnap.data().type;
                    this.email = userSnap.data().email;
                    this.bio = userSnap.data().bio;
                    this.facebook = userSnap.data().facebookLink;
                    this.instagram = userSnap.data().instagramLink;
                    this.twitter = userSnap.data().twitterLink;
                    this.snap = userSnap.data().snapLink;
                    this.facebookLink = "https://tiktok.com/@"+userSnap.data().facebookLink;
                    this.instagramLink = "https://instagram.com/"+userSnap.data().instagramLink;
                    this.twitterLink = "https://x.com/"+userSnap.data().twitterLink;
                    this.snapLink = "https://www.snapchat.com/add/"+userSnap.data().snapLink;
                    this.postCount = userSnap.data().postCount;
                    this.mediaCount = userSnap.data().mediaCount;

                    this.gender = userSnap.data().gender;
                    this.sexuality = userSnap.data().sexuality;

                    sessionStorage.setItem("profilePic", this.profilePic);
                    sessionStorage.setItem("profileBack", this.profileBack);
                    sessionStorage.setItem("userName", this.userName);
                    sessionStorage.setItem("fullName", this.displayName);
                    sessionStorage.setItem("fanCount", this.fanCount);
                    sessionStorage.setItem("followingCount", this.followingCount);
                    sessionStorage.setItem("followersCount", this.followersCount);
                    sessionStorage.setItem("likes", this.likes);
                    sessionStorage.setItem("userType", this.userType);
                    sessionStorage.setItem("email", this.email);
                    sessionStorage.setItem("emailNoti", userSnap.data().emailNoti);
                    sessionStorage.setItem("pushNoti", userSnap.data().pushNoti);
                    sessionStorage.setItem("siteNoti", userSnap.data().siteNoti);

                }
                else{
                    this.$router.push({name: 'sign-in'});
                    return;
                }

                this.$refs.loadingModal.classList.remove("bg-active");

            },

            async commentClick(post, index){

                this.commentCount = post.commentCount;
                this.postId = post.id;
                this.postIndex = index;

                this.comments =[];
                this.commentInput ="";

                const q = query(collection(db, "UserPosts", this.postId, "Comments"), orderBy("dateN"), limit(20));
                const querySnapshot = await getDocs(q);
                
                querySnapshot.forEach((doc) => {
                    this.comments.push({
                        userId: doc.data().userId,
                        profilePic: doc.data().profilePic,
                        name: doc.data().name,
                        userName: doc.data().userName,
                        comment: doc.data().comment,
                        date: doc.data().date,
                    });
                });
                

            },

            downloadAll(mediaList){

                mediaList.forEach(function (e) {                
                    fetch(e.url)                  
                        .then(res => res.blob())                  
                        .then(blob => {                    
                            saveAs(blob, e.name);                
                        });            
                });

            },

            async likeClick(id, index, post){

                const auth = getAuth();

                this.likeSpamList.push(post.id);


                $("#"+id).toggleClass("text-danger bg-danger-4 hp-bg-color-dark-danger");
                $("#"+id).toggleClass("text-black-40 hp-text-color-dark-70 bg-black-10 hp-bg-color-dark-90");

                //update list
                if(post.isLiked){
                    this.postsList[index].likeCount--;
                    this.postsList[index].isLiked = false;

                    if(this.getOccurrence(this.likeSpamList, post.id) > 2){
                        return;
                    }

                    const postRef = doc(db, "UserPosts", post.id);
                    await updateDoc(postRef, {
                        likeCount: increment(-1),
                        
                    });

                    const userRef = doc(db, "Users", post.userId);
                    await updateDoc(userRef, {
                        likes: increment(-1),
                        likesN: increment(1)
                    });

                    await deleteDoc(doc(db, "UserPosts", post.id, "LikedList", auth.currentUser.uid));
                    await deleteDoc(doc(db, "UserLikes", auth.currentUser.uid, "likedList", post.id));
                }

                else{
                    this.postsList[index].likeCount++;
                    this.postsList[index].isLiked = true;

                    if(this.getOccurrence(this.likeSpamList, post.id) > 2){
                        return;
                    }

                    const postRef = doc(db, "UserPosts", post.id);
                    await updateDoc(postRef, {
                        likeCount: increment(1),
                        
                    });

                    const userRef = doc(db, "Users", post.userId);
                    await updateDoc(userRef, {
                        likes: increment(1),
                        likesN: increment(-1)
                    });

                    let mSecs = new Date().getTime() / 1000;
                    let secs = 10000000000 / mSecs;

                    await setDoc(doc(db, "UserPosts", post.id, "LikedList", auth.currentUser.uid), {
                        timeStamp: serverTimestamp(),
                        timeStampN: secs
                    });

                    await setDoc(doc(db, "UserLikes", auth.currentUser.uid, "LikedList", post.id), {
                        timeStamp: serverTimestamp(),
                        timeStampN: secs
                    });
                }
                
            },

            async bookClick(id, index, post){

                $("#"+id).toggleClass("text-primary bg-primary-4 hp-bg-color-dark-primary");
                $("#"+id).toggleClass("text-black-40 hp-text-color-dark-70 bg-black-10 hp-bg-color-dark-90");

                const auth = getAuth();
                this.bookSpamList.push(post.id);

                //update list
                if(post.isBookmarked){
                    this.postsList[index].bookmarkCount--;
                    this.postsList[index].isBookmarked = false;

                    if(this.getOccurrence(this.bookSpamList, post.id) > 2){
                        return;
                    }

                    const postRef = doc(db, "UserPosts", post.id);
                    await updateDoc(postRef, {
                        bookmarkCount: increment(-1),
                        
                    });

                    //remove bookmark post
                    await deleteDoc(doc(db, "UserPosts", post.id, "BookmarkList", auth.currentUser.uid));
                    await deleteDoc(doc(db, "UserBookmarks", auth.currentUser.uid, "BookmarkList", post.id ));
                }

                else{
                    this.postsList[index].bookmarkCount++;
                    this.postsList[index].isBookmarked = true;

                    if(this.getOccurrence(this.bookSpamList, post.id) > 2){
                        return;
                    }

                    const postRef = doc(db, "UserPosts", post.id);
                    await updateDoc(postRef, {
                        bookmarkCount: increment(1),
                        
                    });

                    //add post to bookmark
                    let mSecs = new Date().getTime() / 1000;
                    let secs = 10000000000 / mSecs

                    //add post to bookmark
                    await setDoc(doc(db, "UserPosts", post.id, "BookmarkList", auth.currentUser.uid), {
                        timeStamp: serverTimestamp(),
                        timeStampN: secs
                    });

                    await setDoc(doc(db, "UserBookmarks", auth.currentUser.uid, "BookmarkList", post.id), {
                        timeStamp: serverTimestamp(),
                        timeStampN: secs
                    });
                }
            },

            async postComment(){

                const auth = getAuth();

                this.commentCount++;

                let a = String(new Date());

                let mSecs = new Date().getTime() / 1000;
                let secs = 10000000000 / mSecs;

                //update list
                let commentObj = {
                    userId: auth.currentUser.uid,
                    profilePic: sessionStorage.getItem("profilePic"),
                    name: sessionStorage.getItem("fullName"),
                    userName: sessionStorage.getItem("userName"),
                    comment: this.commentInput,
                    date: a.slice(0, -36),
                    dateN: secs
                }

                this.comments.unshift(commentObj);
                document.getElementById("comDiv").scrollIntoView();
                
                //update post comment db
                const postRef = doc(db, "UserPosts", this.postId);
                await updateDoc(postRef, {
                    
                    commentCount: increment(1),

                });

                await addDoc(collection(db, "UserPosts", this.postId, "Comments"), {
                    userId: auth.currentUser.uid,
                    profilePic: sessionStorage.getItem("profilePic"),
                    name: sessionStorage.getItem("fullName"),
                    userName: sessionStorage.getItem("userName"),
                    comment: this.commentInput,
                    date: a.slice(0, -36),
                    dateN: secs
                });

                this.commentInput = "";
                this.postsList[this.postIndex].commentCount++;

            },

            galleryBtnClick(post){

                this.mediaUrl = post.mediaList[0].url;
                this.mediaType = post.mediaList[0].type;
                this.modelUsername = post.userName;
                this.mediaList = post.mediaList;

            },

            playMedia(media){

                this.mediaName = media.name;
                this.mediaType = media.type;
                this.mediaUrl = media.url;
                this.mediaSize = media.size
                //this.$refs.showModal.classList.add("bg-active");

            },

            compressImg(imgFile){

                //compress file
                    new Compressor(imgFile, {
                        quality: 0.6,
                        width: 1024,
                        // The compression process is asynchronous,
                        // which means you have to access the `result` in the `success` hook function.
                        success(result) {
                            return result;
                        },
                        error(err) {
                            console.log(err.message);
                            return;
                        },
                    });

            },

            profileBackPreview(){

                const fileReader = new FileReader();

                if(document.getElementById("profileBackSelect").files[0] == null){
                    return;
                }

                fileReader.readAsDataURL(document.getElementById("profileBackSelect").files[0]);
                fileReader.addEventListener("load", function () {
                    document.getElementById("profileBack").src = this.result;
                }); 


            },

            profilePicPreview(){

                const fileReader = new FileReader();

                if(document.getElementById("profilePicSelect").files[0] == null){
                    return;
                }

                fileReader.readAsDataURL(document.getElementById("profilePicSelect").files[0]);
                fileReader.addEventListener("load", function () {
                    document.getElementById("profilePic").src = this.result;
                }); 


            },

            async saveInfo(){

                this.loadingText = "Saving user info...";
                this.$refs.loadingModal.classList.add("bg-active");

                if(this.userName == ''){
        
                    this.$refs.loadingModal.classList.remove("bg-active");
                    this.$refs.errorModal.classList.add("bg-active");
                    this.errorText = "Please add a valid username before saving.";
                    return;

                }

                if(this.displayName == ''){
        
                    this.$refs.loadingModal.classList.remove("bg-active");
                    this.$refs.errorModal.classList.add("bg-active");
                    this.errorText = "Please add a valid display name before saving.";
                    return;

                }

                if(this.displayName.toLowerCase() == 'baesnap' ){
        
                    this.$refs.loadingModal.classList.remove("bg-active");
                    this.$refs.errorModal.classList.add("bg-active");
                    this.errorText = "Cannot set display name to baesnap.";
                    return;

                }

                //check username
                if(this.userName != sessionStorage.getItem('userName')){

                    const q = query(collection(db, "Users"), where("displayId", "==", this.userName.toLowerCase()));

                    const querySnapshot = await getDocs(q);
                    if(querySnapshot.docs.length > 0){
                        this.$refs.loadingModal.classList.remove("bg-active");
                        this.$refs.errorModal.classList.add("bg-active");
                        this.errorText = "Username already exists.";
                        return;
                    }

                }

                //profilepic size
                if(document.getElementById("profilePicSelect").files[0] != null && document.getElementById("profilePicSelect").files[0].size > 20971520){
                    this.errorText = "The profile image is too large. Maximum size for images is 20MB. Please change the image to proceed.";
                    this.$refs.loadingModal.classList.remove("bg-active");
                    this.$refs.errorModal.classList.add("bg-active");
                    return;
                }

                //profile back size
                if(document.getElementById("profileBackSelect").files[0] != null && document.getElementById("profileBackSelect").files[0].size > 20971520){
                    this.errorText = "The background image is too large. Maximum size for images is 20MB. Please change the image to proceed.";
                    this.$refs.loadingModal.classList.remove("bg-active");
                    this.$refs.errorModal.classList.add("bg-active");
                    return;
                }

                const auth = getAuth();
                const storage = getStorage();

                let saveName = this.displayName;
                let saveDisplayId = String(this.userName).toLowerCase();

                //update db
                const userRef = doc(db, "Users", auth.currentUser.uid);
                await updateDoc(userRef, {

                    name: saveName.trim(),
                    displayId: saveDisplayId.trim(),
                    bio: this.bio,
                    phone: this.phone,
                    facebookLink: this.facebook,
                    instagramLink: this.instagram,
                    twitterLink: this.twitter,
                    snapLink: this.snap,
                    gender: this.gender,
                    sexuality: this.sexuality

                });

                //upload profile pic
                if(document.getElementById("profilePicSelect").files[0] != null){

                    await this.uploadProfilePic(storage, document.getElementById("profilePicSelect").files[0], auth.currentUser.uid);
                    
                }

                //upload back pic
                if(document.getElementById("profileBackSelect").files[0] != null){
                    
                    await this.uploadProfileBack(storage, document.getElementById("profileBackSelect").files[0], auth.currentUser.uid);

                }

                this.successText = "User info was saved successfully...";
                this.$refs.loadingModal.classList.remove("bg-active");
                this.$refs.successModal.classList.add("bg-active");
            },

            uploadProfilePic(storage, imageFile, userId){
                this.loadingText = "Saving new profile image...";

                return new Promise(function (resolve, reject) {

                    new Compressor(imageFile, {
                        quality: 0.6,
                        width: 1024,
                        // The compression process is asynchronous,
                        // which means you have to access the `result` in the `success` hook function.
                        success(result) {

                            const storageRef = ref(storage, 'UserProfilePics/'+userId+'/' + result.name);
                            const uploadTask = uploadBytesResumable(storageRef, result);

                            //Update progress bar
                            uploadTask.on('state_changed',
                            (snapshot) => {
                                // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
                                const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                                // console.log('Upload is ' + progress + '% done');
                                switch (snapshot.state) {
                                case 'paused':
                                    //console.log('Upload is paused');
                                    break;
                                case 'running':
                                    //console.log('Upload is running');
                                    break;
                                }
                            },
                            (error) => {
                                switch (error.code) {
                                case 'storage/unauthorized':
                                    // User doesn't have permission to access the object
                                    break;
                                case 'storage/canceled':
                                    // User canceled the upload
                                    break;
                                case 'storage/unknown':
                                    // Unknown error occurred, inspect error.serverResponse
                                    
                                    console.log(error.serverResponse);
                                    return;
                                    break;
                                }
                            }, 
                            () => {
                                // Upload completed successfully, now we can get the download URL
                                getDownloadURL(uploadTask.snapshot.ref).then(async (downloadURL) => {

                                    const userRef = doc(db, "Users", userId);
                                    await updateDoc(userRef, {
                                                        
                                        profilePic: downloadURL,
                                                        
                                    });
                            
                                    setTimeout(resolve, 2000);

                                });
                            }); 
                            
                        },
                        error(err) {
                            console.log(err.message);
                            return;
                        },
                    });
                            
                    
                });

            },

            uploadProfileBack(storage, imageFile, userId){

                this.loadingText= "Saving new profile background image...";
                    

                return new Promise(function (resolve, reject) {

                    //compress file
                    new Compressor(imageFile, {
                        quality: 0.6,
                        width: 1024,
                        // The compression process is asynchronous,
                        // which means you have to access the `result` in the `success` hook function.
                        success(result) {

                            const storageRef = ref(storage, 'UserBackPics/'+userId+'/' + result.name);
                            const uploadTask = uploadBytesResumable(storageRef, result);

                            //Update progress bar
                            uploadTask.on('state_changed',
                            (snapshot) => {
                                // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
                                const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                                // console.log('Upload is ' + progress + '% done');
                                switch (snapshot.state) {
                                case 'paused':
                                    //console.log('Upload is paused');
                                    break;
                                case 'running':
                                    //console.log('Upload is running');
                                    break;
                                }
                            },
                            (error) => {
                                switch (error.code) {
                                case 'storage/unauthorized':
                                    // User doesn't have permission to access the object
                                    break;
                                case 'storage/canceled':
                                    // User canceled the upload
                                    break;
                                case 'storage/unknown':
                                    // Unknown error occurred, inspect error.serverResponse
                                    
                                    console.log(error.serverResponse);
                                    return;
                                    break;
                                }
                            }, 
                            () => {
                                // Upload completed successfully, now we can get the download URL
                                getDownloadURL(uploadTask.snapshot.ref).then(async (downloadURL) => {

                                    const userRef = doc(db, "Users", userId);
                                    await updateDoc(userRef, {
                                                        
                                        profileBackground: downloadURL,
                                                        
                                    });
                            
                                    setTimeout(resolve, 2000);

                                });
                            }); 
                            
                        },
                        error(err) {
                            console.log(err.message);
                            return;
                        },
                    });
                    
                });

            },

            uploadProfilePic2(storage, imageFile, userId){
                this.loadingText = "Saving new profile image...";

                return new Promise(function (resolve, reject) {

                    //upload brand logos
                            const storageRef = ref(storage, 'UserProfilePics/'+userId+'/' + imageFile.name);
                            const uploadTask = uploadBytesResumable(storageRef, imageFile);

                            //Update progress bar
                            uploadTask.on('state_changed',
                            (snapshot) => {
                                // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
                                const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                                // console.log('Upload is ' + progress + '% done');
                                switch (snapshot.state) {
                                case 'paused':
                                    //console.log('Upload is paused');
                                    break;
                                case 'running':
                                    //console.log('Upload is running');
                                    break;
                                }
                            },
                            (error) => {
                                switch (error.code) {
                                case 'storage/unauthorized':
                                    // User doesn't have permission to access the object
                                    break;
                                case 'storage/canceled':
                                    // User canceled the upload
                                    break;
                                case 'storage/unknown':
                                    // Unknown error occurred, inspect error.serverResponse
                                    this.errorText = "Unknown error occured";
                                    this.$refs.loadingModal.classList.remove("bg-active");
                                    this.$refs.errorModal.classList.add("bg-active");
                                    console.log(error.serverResponse);
                                    return;
                                    break;
                                }
                            }, 
                            () => {
                                // Upload completed successfully, now we can get the download URL
                                getDownloadURL(uploadTask.snapshot.ref).then(async (downloadURL) => {

                                    const userRef = doc(db, "Users", userId);
                                    await updateDoc(userRef, {
                                                        
                                        profilePic: downloadURL,
                                                        
                                    });
                            
                                    setTimeout(resolve, 2000);

                                });
                            }); 

                            // Listen for state changes, errors, and completion of the upload.
                            
                    
                });

            },

            async getUserInfoPost(userId){

                let isOwner =false; 
                let isSubscribed = false; 
                let fanList =[];

                const auth = getAuth();

                const userRef = doc(db, "Users", userId);
                const userSnap = await getDoc(userRef);

                const querySnapshot = await getDocs(collection(db, "UserFans", userId, "Fans"));
                querySnapshot.forEach((doc) => {
                    fanList.push(doc.id);
                });

                //check if owner
                if(auth.currentUser.uid == userId){
                    isOwner = true;
                    isSubscribed = true;
                }
                else{
                    for(let i=0; i < fanList.length ; i++){
                        if(fanList[i] == auth.currentUser.uid){
                            isSubscribed = true;
                        }
                    }
                }

                return {
                    profilePic : userSnap.data().profilePic,
                    fullName: userSnap.data().name,
                    userName : userSnap.data().displayId,
                    email: userSnap.data().email,
                    userType : userSnap.data().type,
                    isOwner : isOwner,
                    isSubscribed: isSubscribed,
                }

            },

            async getPosts(){

                //start loading
                const auth = getAuth();
                let res = [];
                
                const q = query(collection(db, "UserPosts"), where('userId', '==', auth.currentUser.uid), orderBy('timeStampN'), limit(5), startAfter(this.lastDocSnapshot || 0));
                const querySnapshot = await getDocs(q);

                res = querySnapshot.docs.map(p => p.data());
                this.lastDocSnapshot = querySnapshot.docs[querySnapshot.docs.length - 1];
                if(querySnapshot.docs.length > 0){

                    document.getElementById('emptyPost').style.display ='none';

                    querySnapshot.forEach(async (doc) => {

                        let urlList = [];
                        let imgCount = 0;
                        let vidCount = 0;

                        let a1 = Number(doc.data().timeStamp.seconds) * 1000;
                        let a2 = String(new Date(Number(doc.data().timeStamp.seconds) * 1000));

                        let result = {
                            isLoading: true,
                            id: doc.id,
                            idD: doc.data().idD,
                            userId: doc.data().userId,
                            fullName: doc.data().fullName,
                            userName: doc.data().username,
                            previewName: doc.data().previewName, 
                            profilePic: doc.data().profilePic,
                            
                            isOwner: false,
                            isSubscribed: false,
                            tags: doc.data().tags,
                            caption: doc.data().caption,
                            category: doc.data().category,

                            timeStamp: doc.data().timeStamp,
                            dateFull: a2.slice(0, -36),
                            dateD: this.timeFormat(a1),


                            price: doc.data().price,
                            previewUrl: doc.data().previewUrl,
                            mediaList: doc.data().mediaList,

                            isLiked: false,
                            isBookmarked: false,

                            likeCount: this.kFormatter(doc.data().likeCount),
                            bookmarkCount: this.kFormatter(doc.data().bookmarkCount),
                            commentCount: this.kFormatter(doc.data().commentCount),

                            toggler: false,
                            urlList: urlList,
                            imgCount: imgCount,
                            vidCount: vidCount,
                            previewUrl2: [doc.data().previewUrl]
                            
                            
                        }

                        this.postsList.push(result);

                        let mIndex = this.postsList.length - 1;

                        await this.getFullName(doc.id, doc.data().userId, doc.data().mediaList, doc.data().previewUrl, mIndex);
                        
                    })

                    this.$refs.loadingModal.classList.remove("bg-active");
                }
                
                return res.length;

            },

            async getPostsMedia(){

                //start loading
                const auth = getAuth();
                let res = [];
                
                const q = query(collection(db, "UserPosts"), where('userId', '==', auth.currentUser.uid), orderBy('timeStampN'), limit(10), startAfter(this.lastDocSnapshot2 || 0));
                const querySnapshot = await getDocs(q);

                res = querySnapshot.docs.map(p => p.data());
                this.lastDocSnapshot2 = querySnapshot.docs[querySnapshot.docs.length - 1];
                if(querySnapshot.docs.length > 0){
                    
                    querySnapshot.forEach(async (doc) => {

                        let urlList = [];
                        let imgCount = 0;
                        let vidCount = 0;

                        let a1 = Number(doc.data().timeStamp.seconds) * 1000;
                        let a2 = String(new Date(Number(doc.data().timeStamp.seconds) * 1000));

                        let result = {

                            
                            mediaList: doc.data().mediaList,

                            isLiked: false,
                            isBookmarked: false,

                            likeCount: this.kFormatter(doc.data().likeCount),
                            bookmarkCount: this.kFormatter(doc.data().bookmarkCount),
                            commentCount: this.kFormatter(doc.data().commentCount),

                            toggler: false,
                            urlList: urlList,
                            imgCount: imgCount,
                            vidCount: vidCount,
                            previewUrl2: [doc.data().previewUrl]

                        }

                        if(doc.data().previewUrl != '' && doc.data().mediaList.length > 0){

                            for(let i = 0; i < doc.data().mediaList.length; i++){

                                let mType = doc.data().mediaList[i].type;
                                if (mType.startsWith('image')){

                                    this.postsMediaList.push({
                                        type: "image",
                                        url: doc.data().mediaList[i].url,
                                        isOwner: true,
                                        subscribed: true,
                                        toggler: false,
                                        urlList: [doc.data().mediaList[i].url]
                                    })

                                }
                                else if (mType.startsWith('video')){

                                    this.postsMediaList.push({
                                        type: "video",
                                        url: doc.data().mediaList[i].url,
                                        isOwner: true,
                                        subscribed: true,
                                        toggler: false,
                                        urlList: [doc.data().mediaList[i].url]
                                    })

                                }
                                
                            }

                            document.getElementById('emptyMedia').style.display ='none';
                            
                        }
                        
                    })

                    this.$refs.loadingModal.classList.remove("bg-active");
                }
                
                return res.length;

            },

            deleteClick(post){
                this.post = post;
            },

            async deletePost(){

                this.loadingText = "Deleting post...";
                this.$refs.loadingModal.classList.add("bg-active");

                const storage = getStorage();
                const auth = getAuth();

                //delete preview
                if(this.post.previewName != ""){
                    const storageRef = ref(storage, 'UserPosts/Preview/' + auth.currentUser.uid + '/' + this.post.id + '/' + this.post.previewName);

                    await deleteObject(storageRef).then(() => {
                    
                    }).catch((error) => {
                        this.errorText = "An error occured while deleting the post";
                        this.$refs.loadingModal.classList.remove("bg-active");
                        this.$refs.errorModal.classList.add("bg-active");
                        console.log(error);
                        return;
                    });
                }


                // delete media
                if(this.post.mediaList.length > 0){
                    for(let i=0 ; i < this.post.mediaList.length ; i++){
                        const storageRef = ref(storage, 'UserPosts/Media/' + auth.currentUser.uid + '/' + this.post.id + '/' + this.post.mediaList[i].name);

                        await deleteObject(storageRef).then(() => {
                    
                        }).catch((error) => {
                            this.errorText = "An error occured while deleting the post";
                            this.$refs.loadingModal.classList.remove("bg-active");
                            this.$refs.errorModal.classList.add("bg-active");
                            console.log(error);
                            return;
                        });
                    }
                }

                await deleteDoc(doc(db, "UserPosts", this.post.id));

                //update count
                const userRef = doc(db, "Users", auth.currentUser.uid);
                await updateDoc(userRef, {
                    postCount: increment(-1),
                    mediaCount: increment(-this.post.mediaList.length)

                });


                this.successText = "Post was deleted successfully";
                this.$refs.loadingModal.classList.remove("bg-active");
                this.$refs.successModal.classList.add("bg-active");

            },

            async getLikedStatus(postId){

                let likedList = [];
                const auth = getAuth();

                const querySnapshot = await getDocs(collection(db, "UserPosts", postId, "LikedList"));
                querySnapshot.forEach((doc) => {
                    likedList.push(doc.id);
                });

                for(let i=0; i < likedList.length ; i++){
                    if(likedList[i] == auth.currentUser.uid){
                        return true
                    }
                }

                return false;

            },

            async getBookmarkStatus(postId){

                const auth = getAuth();
                let bookmarkList = [];

                const querySnapshot = await getDocs(collection(db, "UserPosts", postId, "BookmarkList"));
                querySnapshot.forEach((doc) => {
                    bookmarkList.push(doc.id);
                });

                for(let i=0; i < bookmarkList.length ; i++){
                    if(bookmarkList[i] == auth.currentUser.uid){
                        return true
                    }
                }

                return false;

            },

            async handleInfinite($state){

                const newPostCount = await this.getPosts();

                    if(newPostCount > 0 ){
                        //more posts
                        return $state.loaded();
                    }

                    //no more posts
                    document.getElementById('emptyPost2').style.display ='none';
                    return $state.complete();

            },

            async handleInfinite2($state){

                const newPostCount = await this.getPostsMedia();

                    if(newPostCount > 0 ){
                        //more posts
                        return $state.loaded();
                    }

                    //no more posts
                    document.getElementById('emptyMedia2').style.display ='none';
                    return $state.complete();
                    

            },

            async getFullName(id, userId, mediaList, previewUrl, mIndex){

                let i = mIndex;
                let fanList = [];
                let likedList = [];
                let bookmarkList = [];

                let urlList = [];
                let imgCount = 0;
                let vidCount = 0;

                for (let a = 0; a < mediaList.length; a++) {
                urlList.push(mediaList[a].url)
                    if (mediaList[a].type.startsWith("image")) {
                        imgCount++;
                    }
                    else if (mediaList[a].type.startsWith("video")) {
                        vidCount++;
                    }
                }

                if(mediaList.length < 1){
                    urlList.push(previewUrl);
                }

                const auth = getAuth();

                const querySnapshot2 = await getDocs(collection(db, "UserPosts", id, "LikedList"));
                querySnapshot2.forEach((doc) => {
                    likedList.push(doc.id);
                });

                const querySnapshot3 = await getDocs(collection(db, "UserPosts", id, "BookmarkList"));
                querySnapshot3.forEach((doc) => {
                    bookmarkList.push(doc.id);
                });

                if(this.postsList[i].id == id){
                    
                        this.postsList[i].fullName = sessionStorage.getItem("fullName")
                        this.postsList[i].userName = sessionStorage.getItem("userName");
                        this.postsList[i].profilePic = sessionStorage.getItem("profilePic");

                        this.postsList[i].urlList = urlList;
                        this.postsList[i].vidCount = vidCount;
                        this.postsList[i].imgCount = imgCount;

                        this.postsList[i].isOwner = true;
                        this.postsList[i].isSubscribed = true;

                        for(let c=0; c < likedList.length ; c++){
                            if(likedList[c] == auth.currentUser.uid){
                                this.postsList[i].isLiked = true;
                                break;
                            }
                        }

                        for(let d=0; d < bookmarkList.length ; d++){
                            if(bookmarkList[d] == auth.currentUser.uid){
                                this.postsList[i].isBookmarked = true;
                                break;
                            }
                        }

                        this.postsList[i].isLoading = false;

                    }

            },

            async getFullName2(id, userId, mediaList, previewUrl, mIndex){

                let i = mIndex;
                let fanList = [];
                let likedList = [];
                let bookmarkList = [];

                let urlList = [];
                let imgCount = 0;
                let vidCount = 0;

                for (let a = 0; a < mediaList.length; a++) {
                urlList.push(mediaList[a].url)
                    if (mediaList[a].type.startsWith("image")) {
                        imgCount++;
                    }
                    else if (mediaList[a].type.startsWith("video")) {
                        vidCount++;
                    }
                }

                if(mediaList.length < 1){
                    urlList.push(previewUrl);
                }

                const auth = getAuth();

                const querySnapshot2 = await getDocs(collection(db, "UserPosts", id, "LikedList"));
                querySnapshot2.forEach((doc) => {
                    likedList.push(doc.id);
                });

                const querySnapshot3 = await getDocs(collection(db, "UserPosts", id, "BookmarkList"));
                querySnapshot3.forEach((doc) => {
                    bookmarkList.push(doc.id);
                });

                if(this.postsMediaList[i].id == id){
                
                        this.postsMediaList[i].fullName = sessionStorage.getItem("fullName");
                        this.postsMediaList[i].userName = sessionStorage.getItem("userName");
                        this.postsMediaList[i].profilePic = sessionStorage.getItem("profilePic");

                        this.postsMediaList[i].urlList = urlList;
                        this.postsMediaList[i].vidCount = vidCount;
                        this.postsMediaList[i].imgCount = imgCount;

                        this.postsMediaList[i].isOwner = true;
                        this.postsMediaList[i].isSubscribed = true;

                        for(let b=0; i < likedList.length ; b++){
                            if(likedList[b] == auth.currentUser.uid){
                                this.postsMediaList[i].isLiked = true;
                                break;
                            }
                        }

                        for(let c=0; c < bookmarkList.length ; c++){
                            if(bookmarkList[c] == auth.currentUser.uid){
                                this.postsMediaList[i].isBookmarked = true;
                                break;
                            }
                        }

                        this.postsMediaList[i].isLoading = false;

                }

                

            },

        }

    }

</script>